import axiosHttp from "./interceptor.service";

const postPublicHoliday = (data) => {
  return axiosHttp.post("/lmt/publicHoliday", data);
};
const getPublicHoliday = ({ year, type } = {}) => {
  return axiosHttp.get("/lmt/getPublicHoliday", { params: { year, type } });
};
const updatePublicHoliday = (id, data) => {
  return axiosHttp.put(`/lmt/updatePublicHoliday/${id}`, data);
};

const deletePublicHoliday = (id, data) => {
  return axiosHttp.delete(`/lmt/deletePublicHoliday/${id}`, data);
};

export {
  postPublicHoliday,
  getPublicHoliday,
  updatePublicHoliday,
  deletePublicHoliday,
};
